import React from 'react';
import { Layers, Sparkles, Info } from 'lucide-react';

/**
 * GOV13-A6 — "Platform Subscription — this pays for" explainer. This is the GENERAL platform capability
 * universe (approved marketing description). It is deliberately SEPARATE from the authoritative per-plan
 * comparison matrix below it: not every capability is included in every plan, and some are optional or set-up
 * required. The exact, truthful per-plan inclusion is shown in <PlanComparison/>, driven entirely by the
 * server catalogue projection. Nothing here asserts plan-specific inclusion.
 */
const CORE_PLATFORM = [
  'User accounts', 'Dashboards', 'Workflows', 'CRM capabilities', 'Ticket management',
  'Knowledge base', 'Marketplace presence', 'Scheduling tools', 'Integrations', 'Administration',
];

const AI_AUTOMATION = [
  'AI Voice Agents', 'AI Phone Calls', 'Multilingual Voice Translation',
  'WhatsApp-to-AI and AI-to-WhatsApp', 'AI Quality Assurance', 'AI Sentiment Analysis',
  'Private Knowledge Bases', 'Industry AI Models', 'Predictive Analytics',
  'Workflow Automation', 'Advanced Reporting',
];

export function PlatformCapabilityUniverse() {
  return (
    <div className="rounded-xl border border-gray-200 bg-white p-5" data-testid="platform-capability-universe">
      <h4 className="text-lg font-semibold text-gray-900">Platform Subscription — what it pays for</h4>
      <div className="mt-1 flex items-start gap-2 text-xs text-gray-500">
        <Info className="h-3.5 w-3.5 mt-0.5 flex-shrink-0" />
        <span>
          This is the Servisfy platform capability universe. Not every capability is included in every plan —
          some are limited, set-up required, or optional add-ons. See the exact per-plan comparison below.
        </span>
      </div>
      <div className="mt-4 grid gap-5 md:grid-cols-2">
        <div>
          <div className="mb-2 flex items-center gap-2 text-sm font-semibold text-blue-800">
            <Layers className="h-4 w-4" /> Core Platform
          </div>
          <ul className="space-y-1.5">
            {CORE_PLATFORM.map((c) => (
              <li key={c} className="flex items-start gap-2 text-sm text-gray-700">
                <span className="mt-1 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-blue-400" />{c}
              </li>
            ))}
          </ul>
        </div>
        <div>
          <div className="mb-2 flex items-center gap-2 text-sm font-semibold text-purple-800">
            <Sparkles className="h-4 w-4" /> AI &amp; Automation
          </div>
          <ul className="space-y-1.5">
            {AI_AUTOMATION.map((c) => (
              <li key={c} className="flex items-start gap-2 text-sm text-gray-700">
                <span className="mt-1 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-purple-400" />{c}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default PlatformCapabilityUniverse;
